var map = {
	"./bank-logos/ID/BRI-Direct.png": "1af4",
	"./bank-logos/ID/ESPAY.png": "16e4",
	"./bank-logos/PH/BPI.svg": "23ab",
	"./bank-logos/PH/GCash.png": "6585",
	"./bank-logos/PH/QRPH.png": "ea8d",
	"./bank-logos/PH/RCBC.svg": "1f4f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";